import { InjectionToken } from "@angular/core";
import { IScheduleReceiverConfigPushModalService } from "./i-schedule-receiver-config-push-modal.service";

export const scheduleReceiverConfigPushModalServiceInjectionToken: InjectionToken<IScheduleReceiverConfigPushModalService> = new InjectionToken<IScheduleReceiverConfigPushModalService>("digital-signage.user-dashboard.dashboard-web.ScheduleReceiverConfigPushModalService");
